import React, { createContext } from 'react';
import axios from 'axios';
import { defaultOrganizationLogo } from '../../helpers/cdn';

export const WelletContext = createContext({
  apis: {
    tickets: axios.create(),
    admin: axios.create()
  },
  app: {
    name: 'Wellet',
    logo: defaultOrganizationLogo,
    language: 'es',
    currencies: {},
    scopeOrganization: -1,
  },
});
